import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo21Y22RMF2026Certificado() {
  return <CategoryPage category="anexo21Y22Rmf2026Certificado" pageTitle="Certificado JSON 2026" />;
}

export default Anexo21Y22RMF2026Certificado;
